import axios from 'axios'
import { Page } from '../types'
import Analytics from 'analytics'

export interface CompanyInfo {
  address: string
  cdnDomain: string
  cellphone: string
  companyName: string
  corpId: string
  defaultCardId: number
  domain: string
  fax: null
  infoCompanyName: string
  officialWebsite: string
  squareLogo: string
  themeColor: string
}
export const queryCompanyInfo = async () => {
  const res = await axios.get('/api/open/v1/wx/companyInfo')
  if (res.data.code === 200) {
    return res.data.data as CompanyInfo
  } else {
    throw new Error(res.data.message)
  }
}

export interface BusinessCard {
  businessCardId: number
  addWeixinQrCode: string
  avatar: string
  portrait: string
  userName: string
  cellphone: string
  email: string
  address: string
  wechat: string
  companyPosition: string
  companyInfo: {
    companyName: string
    squareLogo: string
    themeColor: string
  }
  chatUrl: string
  posterUrl: string
  vcardUrl: string
}
export const queryBusinessCard = async (cardId: string) => {
  const res = await axios.get(`/api/open/ca/v1/businessCard/getBusinessCard/${cardId}`)
  if (res.data.code === 200) {
    return res.data.data as BusinessCard
  } else {
    throw new Error(res.data.message)
  }
}

export type MenuType = 'IMAGE' | 'VIDEO' | 'FILE' | 'URL'
export interface Menu {
  businessCardMenuId: number
  menuName: string
  url: string
  type: MenuType
  fileCountStr: string
  sort: number
}
export const queryMenus = async () => {
  const res = await axios.get('/api/open/ca/v1/businessCard/getBusinessCardMenu')
  if (res.data.code === 200) {
    return res.data.data as Menu[]
  } else {
    throw new Error(res.data.message)
  }
}

export interface Visitors {
  avatars: string[]
  count: number
}
export const queryVisitors = async (businessCardId: number) => {
  const res = await axios.get(`/api/open/ca/v1/businessCard/getBrowsedRecord/${businessCardId}`)
  if (res.data.code === 200) {
    return res.data.data as Visitors
  } else {
    throw new Error(res.data.message)
  }
}

export interface Resource {
  src: string
  size: number
  fileSuffix: string
  accessType: number
  type: number
  typeStr: string
  resourceType: string
}
export interface User {
  companyUserId: number
  name: string
  nickName: string
  avatar: string
}
export interface Asset {
  assertId: number
  assertName: string
  describe: string
  isDir: 0 | 1
  fileCount: number
  fileCoverUrl: string
  uuid: string
  checkFileUploadType: boolean
  fileType: string
  resource: Resource
  createTime: string
  updateTime: string
  tagsName: string
  viewCount: number
  uploader: User
}
export const queryAssets = async (menuId: number, page: number) => {
  const res = await axios.get(`/api/open/ca/v1/businessCard/companyDigitalAssets/${menuId}`, {
    params: { page }
  })
  if (res.data.code === 200) {
    return res.data.data as Page<Asset>
  } else {
    throw new Error(res.data.message)
  }
}
export const queryAsset = async (assetId: number) => {
  const res = await axios.get(`/api/open/ca/v1/businessCard/companyDigitalAssets/getDetail/${assetId}`)
  if (res.data.code === 200) {
    return res.data.data as Asset
  } else {
    throw new Error(res.data.message)
  }
}

export type Behavior = 'VISIT_PAGE' | 'VIEW_ASSET' | 'VISIT_BUSINESS_CARD'
export type AnalyticsData = any
export const postAnalytics = (behaviorCode: Behavior, data: AnalyticsData) => {
  return axios.post(`/api/open/v1/analytics/track`, data, { params: { behaviorCode } })
}
export const analytics = Analytics({
  app: 'MarketUP-Business',
  version: '1.0',
  plugins: [
    {
      name: 'marketup-analytics-plugin',
      page: ({ payload }: any) => postAnalytics('VISIT_PAGE', payload),
      track: ({ payload }: any) => postAnalytics(payload.event, payload)
    }
  ]
})
